"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledListboxGroup = void 0;
var _ListboxGroup = require("./ListboxGroup");
// TODO: in v9, move styled() from ListboxGroup.jsx to here
var StyledListboxGroup = _ListboxGroup.ListboxGroup;
exports.StyledListboxGroup = StyledListboxGroup;